/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { UserRoles } from 'shared/enums/Roles';
import CustomCheckbox from 'components/CustomCheckbox';
import RoleChip from 'components/common/RoleChip';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& > * ': {
      marginTop: theme.spacing(2),
    },
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-evenly',
    marginTop: '1.5rem',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function RoleSelector({ onRoleChange, roles, editRole }) {
  const classes = useStyles();
  const [values, setValues] = useState(roles ?? []);
  const { t } = useTranslation();

  const onChange = (evt) => {
    const { value } = evt.target;
    const newArray = [...values];
    const indexOfExistingValue = newArray.findIndex(existingValue => value === existingValue);
    if (indexOfExistingValue > -1) {
      newArray.splice(indexOfExistingValue, 1);
    } else {
      newArray.push(value);
    }

    setValues(newArray);
    if (onRoleChange) onRoleChange(value);
  };

  return (
    <div aria-label={t('user.roles')} className={classes.checkboxGroup}>
      {Object.keys(UserRoles)?.map((key) => {
        return (
          <div aria-label={t(UserRoles[key].i18nKey)} key={UserRoles[key].id} className={classes.checkboxContainer}>
            <CustomCheckbox
              name={UserRoles[key].id}
              value={UserRoles[key].id}
              checked={!!values?.find(value => value === UserRoles[key].id)}
              onChange={onChange}
            />
            <RoleChip role={UserRoles[key].id} />
          </div>
        );
      })}
      {values.length === 0 && editRole && (
        <div className={classes.root}>
          <Alert severity="warning">
            <AlertTitle>{t('user-management.warning')}</AlertTitle>
            {t('user-management.warning.edit.role.missing')}
          </Alert>
        </div>
      )}
    </div>
  );
}
